'use client';

import BrandedLoadingSpinner from '@/components/shared/BrandedLoadingSpinner';

/**
 * Loading state for /auth and all /auth/* routes.
 * Shown while navigating between sign-in, registration, and verification pages.
 */
export default function AuthLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <BrandedLoadingSpinner
        mode="default"
        size="lg"
        message="Loading"
        subMessage="Preparing secure sign-in"
        showLogo
        showTagline
        showProgressBar={false}
      />
    </div>
  );
}
